export const tags = {
  view: {
    title: "Project Tags",
    subtitle: "Set global project tags for all recordings in this project",
    subjectTags: {
      title: "Subject Tags",
      description: "Add subject tags that apply universally to all recordings in this project. These tags help make it easier to search and filter recordings in the app.",
      placeholder: "Type and press ',' to add tags"
    },
    contentTag: {
      title: "Content Tag",
      description: "Set a content tag that indicates the target audience or content rating for this project. This tag helps classify the project's content appropriateness.",
      placeholder: "Select a content tag"
    }
  }
}
